import Vue from 'vue'
import Vuex from 'vuex'
import { resolve } from 'url'
import createPersistedState from 'vuex-persistedstate'
import axios from '@/services/base'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: '',
    user: { cover: { url: '' }, realname: '', id: '', forum_unread: false, onboarding_done: true },
    lobby: { id: '', live: false, pug_server: { ip: '' } }
  },
  mutations: {
    login(state, token, user) {
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_success(state, token, user) {
    },
    update_user(state, user) {
      state.user = user
    },
    updateLobby(state, lobby) {
      state.lobby = lobby
    },
    leaveLobby(state, forceLeave) {
      if (!state.lobby.live || forceLeave)
        state.lobby = { id: '', live: false, pug_server: { ip: '' } }
    },
    clearLobby(state) {
      state.lobby = { id: '', live: false, pug_server: { ip: '' } }
    },
    auth_error(state) {
      state.status = 'error'
    },
    redirecting_to_login(state) {
      state.status = 'redirecting'
    },
    updateUser(state, user) {
      state.user = user
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user = { cover: { url: '' }, realname: '', id: '' }
    },
    remove_forum_unread(state) {
      state.user.forum_unread = false
    },
    add_forum_unread(state) {
      state.user.forum_unread = true
    },
    remove_notification_unread(state) {
      state.user.notifications_count = 0
    },
    add_notification_unread(state) {
      state.user.notifications_count = 1
    },
    updateNotificationsCount(state, notificationsCount) {
      state.user.notifications_count = notificationsCount
    }
  },
  actions: {
    login({commit}, token) {
      commit('login', token)
      axios.defaults.headers.common['Authorization'] = token;
      axios.get('pages/my_account.json')
        .then(function (response) {
          commit('updateUser', response.data)
        })
    },
    logout({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    updateUserProfile({commit}, user) {
      commit('update_user', user)
    },
    updateLobby({commit}, lobby) {
      commit('updateLobby', lobby)
    },
    leaveLobby({commit}, lobby) {
      commit('leaveLobby', lobby)
    },
    redirectingToLogin({commit}) {
      commit('redirecting_to_login')
    },
    addForumUnread({commit}) {
      commit('add_forum_unread')
    },
    removeForumUnread({commit}) {
      commit('remove_forum_unread')
    },
    addNotificationUnread({commit}) {
      commit('add_notification_unread')
    },
    removeNotificationUnread({commit}) {
      commit('remove_notification_unread')
    },
    updateNotificationsCount({commit}, notificationsCount) {
      commit('updateNotificationsCount', notificationsCount)
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    token: state => state.token,
    authStatus: state => state.status,
    user: state => state.user,
    lobby: state => state.lobby
  },
  plugins: [createPersistedState({ key: 'queotaClub' })]
})
